export default {
    domain: 'https://accupace.accupin.com/',
    baseApi: 'https://accupace.accupin.com/api',
};